// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2l1bV","row":"styles_row__3HPoM"};